import { useContext } from "react";
import { DocumentViewerContext } from "./DocumentViewerContext";
import { DocumentViewerContextValue } from "./DocumentViewerContext.types";

export function useDocumentViewer(): DocumentViewerContextValue {
    const ctx = useContext(DocumentViewerContext);
    if (!ctx)
        throw new Error(
            "useDocumentViewer must be used within DocumentViewerProvider"
        );
    return ctx;
}
